import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SearchScreenComponent } from './components/search-screen/search-screen.component';
import { ProductScreenComponent } from './components/product-screen/product-screen.component';
import { PricingScreenComponent } from './components/pricing-screen/pricing-screen.component';
import { AboutUsComponent } from './commons/about-us/about-us.component';
import { PrivacyPolicyComponent } from './commons/privacy-policy/privacy-policy.component';
import { TermsOfServiceComponent } from './commons/terms-of-service/terms-of-service.component';
import { ErrorPageComponent } from './commons/error-page/error-page.component';
import { LoginComponent } from './auth/login/login.component';
import { RegisterComponent } from './auth/register/register.component';
import { ForgotPasswordComponent } from './auth/forgot-password/forgot-password.component';
import { UpdatePasswordComponent } from './auth/update-password/update-password.component';
import { TokenVerificationComponent } from './auth/token-verification/token-verification.component';
import { ResetPasswordComponent } from './auth/reset-password/reset-password.component';
import { UpdateEmailComponent } from './auth/update-email/update-email.component';
import { SettingsComponent } from './payment/settings/settings.component';
import { ContactComponent } from './commons/contact/contact.component';
import { CartViewComponent } from './payment/cart-view/cart-view.component';
import { EmailVerificationComponent } from './auth/email-verification/email-verification.component';
import { AccountDisabledComponent } from './auth/account-disabled/account-disabled.component';
import { AuthGuardService } from './auth/auth-guard.service';
import { SubPricingComponent } from './commons/sub-pricing/sub-pricing.component';
import { SuccessComponent } from './payment/success/success.component';
import { HomeComponent } from './components/home/home.component';
import { HistoricalPricingComponent } from './components/historical-pricing/historical-pricing.component';
import { ProductDisplayComponent } from './components/product-display/product-display.component';

const routes: Routes = [
  { path: '', component: HomeComponent},
  // app components
  { path: 'search', component: SearchScreenComponent, canActivate: [AuthGuardService] },
  { path: 'product-display', component: ProductDisplayComponent, canActivate: [AuthGuardService] },
  { path: 'price-history', component: HistoricalPricingComponent, canActivate: [AuthGuardService] },
  { path: 'product', component: ProductScreenComponent, canActivate: [AuthGuardService] },
  { path: 'pricing', component: PricingScreenComponent, canActivate: [AuthGuardService] },// this is the calculator page of the application
  { path: 'historical-pricing', component: HistoricalPricingComponent, canActivate: [AuthGuardService]},
  // finance components
  { path: 'success', component: SuccessComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true } },
  { path: 'cart-view', component: CartViewComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true } },
  { path: 'sub-pricing', component: SubPricingComponent },
  { path: 'settings', component: SettingsComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true } },

  // auth components
  { path: 'login', component: LoginComponent, canActivate: [AuthGuardService], data: { loggedOutAccessOnly: true } },
  { path: 'register', component: RegisterComponent, canActivate: [AuthGuardService], data: { loggedOutAccessOnly: true } },
  { path: 'update-email', component: UpdateEmailComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true } },
  { path: 'account-disabled', component: AccountDisabledComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true } },
  { path: 'email-confirmation', component: EmailVerificationComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true } },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'update-password', component: UpdatePasswordComponent, canActivate: [AuthGuardService], data: { loggedInAccessOnly: true } },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'verification', component: TokenVerificationComponent },

  // common components
  { path: 'about', component: AboutUsComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-of-service', component: TermsOfServiceComponent },
  { path: 'contact', component: ContactComponent },
  
  { path: '**', component: ErrorPageComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
